import { render, staticRenderFns } from "./UserAbout.vue?vue&type=template&id=7fcb4e2e&"
import script from "./UserAbout.vue?vue&type=script&lang=js&"
export * from "./UserAbout.vue?vue&type=script&lang=js&"
import style0 from "./UserAbout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports